import api from "../interceptor/interceptor";

const TripsDetailsService = {
    async getTripDetails(tripID) {
        try {
            const response = await api.get(`/api/trip/details/${tripID}`);
            return response.data[0];
        } catch (e) {
            return {
                message: e.response.data.errors
            }
        }
    }
}

export default TripsDetailsService;
